import {Repository} from './Repository';

export default class NotificationRepository extends Repository {
    constructor() {
        super();
        this.notificationRequestPrefix = '/api/v1/notifications';
    }

    t

    getNotifications = (url) => {
        return this.getRequestPromise('get', this.notificationRequestPrefix + `/${url}`);
    }

    updateNotificationEnable = (url) => {
        return this.getRequestPromise('put', this.notificationRequestPrefix + `/${url}`);
    }

    getNotificationInfo = (url) => {
        return this.getRequestPromise('get', this.notificationRequestPrefix + `/${url}`);
    };

    postNotice = (data) => {
        return this.getRequestPromise('post', this.notificationRequestPrefix, data);
    }

    putNotice = (data) => {
        return this.getRequestPromise('put', this.notificationRequestPrefix, data);
    }

    deleteNotice = (id) => {
        return this.getRequestPromise('delete', this.notificationRequestPrefix + `?id=${id}`);
    }

}